import {
  Dialog, DialogTitle, DialogContent, Typography, DialogActions, Button,
} from '@mui/material';
import React from 'react';

interface DeleteConfirmationModalProps {
  open: boolean;
  onCancel: () => void;
  onConfirm: () => void;
  isDeleting: boolean;
  jobIsCompleted: boolean;
}

/**
 * Confirmation dialog when deleting a vendor statement job
 * @param open - Whether the dialog is open
 * @param onConfirm - Function to call when the user confirms the deletion
 * @param onCancel - Function to call when the user cancels the deletion
 * @param isDeleting - Whether the deletion is in progress
 * @param jobIsCompleted - Whether the job is completed (and therefore loaded into BigQuery)
 * @constructor
 * @returns
 */
// eslint-disable-next-line import/prefer-default-export
export const DeleteConfirmationModal = function ({
  open,
  onCancel,
  onConfirm,
  isDeleting,
  jobIsCompleted,
}: DeleteConfirmationModalProps) {
  return (
    <Dialog open={open} onClose={onCancel}>
      <DialogTitle>Delete Vendor Statement</DialogTitle>
      <DialogContent>
        <Typography>
          Are you sure you want to delete this vendor statement job?
          <br />
          <br />
          {jobIsCompleted && (
            <>
              This statement is completed and will be removed from BigQuery on the next hourly sync.
              <br />
              <br />
            </>
          )}
          This action cannot be undone.
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancel} disabled={isDeleting}>
          Cancel
        </Button>
        <Button
          onClick={onConfirm}
          color="error"
          variant="contained"
          disabled={isDeleting}
        >
          {isDeleting ? 'Deleting...' : 'Delete'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
